export default __webpack_public_path__ + "static/media/lastPage.cc01a4bb.png";